import React, { useState } from 'react';
import '../styles/faqsection.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const faqData = [
  {
    question: 'Can I attempt a test multiple times?',
    answer: 'A Practice Exam which is subscribed by you can be attempted as many times as you want.',
  },
  {
    question: 'Will I get my performance analysis and solutions after the test?',
    answer: 'Yes, you will get a detailed analysis of your performance along with correct answers and explanations after completing the test',
  },
  {
    question: 'Can I download the practice test with solutions after the test?',
    answer: 'No, you cannot download the test, however, you can access and analyse performance of recently attempted tests.',
  },
  {
    question: 'When I re-attempt the same test, are the questions same as previous test?',
    answer: 'No, You will get a unique practice test every time you attempt a test. However, some questions can repeat after many number of attempts.',
  },
  {
    question: 'How accurate are your practice exams?',
    answer: 'Our practice exams are developed by experts and closely mimic real exam formats and difficulty levels.',
  },
  {
    question: 'How my rank for a particular test is calculated?',
    answer: 'Your rank is calculated by comparing your score with other aspirants who attempted the same test.',
  },
  {
    question: 'How often are practice exams updated with new questions?',
    answer: 'New questions are added regularly based on syllabus updates and user feedback.',
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // keyboard handler for accessibility
  const onKey = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleFAQ(index);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = (index + 1) % faqData.length;
      document.querySelectorAll('.faq-question-btn')[next]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = (index - 1 + faqData.length) % faqData.length;
      document.querySelectorAll('.faq-question-btn')[prev]?.focus();
    }
  };

  return (
    <section className="faq-section" aria-labelledby="faq-heading">
      <div className="faq-wrap">
        <div className="faq-header">
          <h2 id="faq-heading" className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">
            Have questions about Poly Quizz? Find answers to commonly asked questions below. If you don't see what you're looking for, reach out to our support team.
          </p>
        </div>

        <div className="faq-list" role="list">
          {faqData.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={index}
                className={`faq-item ${open ? 'open' : ''}`}
                role="listitem"
              >
                <div
                  className="faq-question"
                  role="button"
                  tabIndex={0}
                  aria-expanded={open}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => toggleFAQ(index)}
                  onKeyDown={(e) => onKey(e, index)}
                  onMouseDown={(e) => e.preventDefault()} // prevent focus loss on click
                >
                  <button
                    type="button"
                    className="faq-question-btn"
                    aria-hidden="true"
                    tabIndex={-1}
                  >
                    <span className="faq-qtext">{item.question}</span>
                    <span className={`faq-icon ${open ? 'rotated' : ''}`} aria-hidden>
                      {open ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  </button>
                </div>

                <div
                  id={`faq-answer-${index}`}
                  className="faq-answer"
                  aria-hidden={!open}
                  style={{ '--max-h': open ? '600px' : '0px' }} // used by CSS for smooth height
                >
                  <div className="faq-answer-inner">{item.answer}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="faq-footer">
          <p>Still have questions?</p>
          <p className="contact-link" aria-label="Contact support">Contact our support team → support@polyquizz.com</p>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
